import { useEffect, useState, useMemo } from "react";
import ResumenGeneral from "@/components/ResumenGeneral";
import ReportesPanel from "@/components/ReportesPanel";
import GraficaConteoLlamadas from "@/components/GraficaConteoLlamadas";
import GraficaLlamadasPie from "@/components/GraficaLlamadasPie";
import GraficaMinutosPie from "@/components/GraficaMinutosPie";
import GraficaCostoPromedioDia from "@/components/GraficaCostoPromedioDia";
import { useSession } from "@/context/SessionProvider";

const isNocAdmin = (u) => [1, 5].includes(Number(u?.perfil_id));

export default function Dashboard() {
    const { user } = useSession();
    const [resumen, setResumen] = useState(null);
    const [detalleData, setDetalleData] = useState([]);
    const [mode, setMode] = useState(() => localStorage.getItem("ui_mode") || "user");
    const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
        const saved = localStorage.getItem("sidebar_collapsed");
        return saved === "true";
    });

    useEffect(() => {
        const h = (e) => setMode(e.detail);
        window.addEventListener("ui-mode-changed", h);
        return () => window.removeEventListener("ui-mode-changed", h);
    }, []);

    useEffect(() => {
        const handleSidebarChange = (e) => setSidebarCollapsed(e.detail);
        window.addEventListener("sidebar-collapsed", handleSidebarChange);
        return () => window.removeEventListener("sidebar-collapsed", handleSidebarChange);
    }, []);

    const admin = useMemo(() => isNocAdmin(user), [user]);
    useEffect(() => {
        if (!admin && mode !== "user") {
            setMode("user");
            localStorage.setItem("ui_mode", "user");
        }
    }, [admin, mode]);

    return (
        <div className="w-full min-w-0 overflow-x-hidden transition-all duration-300">
            <div className={`mx-auto w-full min-w-0 px-2 sm:px-4 space-y-4 transition-all duration-300 ${sidebarCollapsed ? 'max-w-[1600px]' : 'max-w-7xl'
                }`}>
                <ResumenGeneral datos={resumen} mode={mode} />

                {/* Graficas: 1 columna en movil, 2x2 en laptop, 4 en fila en desktop ancho */}
                <section className="mt-2">
                    <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4 gap-4 lg:gap-6 lg:justify-items-center">
                        <div className="w-full max-w-2xl lg:max-w-md">
                            <GraficaConteoLlamadas
                                resumen={resumen}
                                detalleData={detalleData}
                                mode={mode}
                            />
                        </div>
                        <div className="w-full max-w-2xl lg:max-w-md">
                            <GraficaCostoPromedioDia detalleData={detalleData} mode={mode} />
                        </div>
                        <div className="w-full max-w-2xl lg:max-w-md">
                            <GraficaMinutosPie resumen={resumen} mode={mode} />
                        </div>
                        <div className="w-full max-w-2xl lg:max-w-md">
                            <GraficaLlamadasPie resumen={resumen} mode={mode} />
                        </div>
                    </div>
                </section>

                <ReportesPanel
                    setResumen={setResumen}
                    setDetalleData={setDetalleData}
                    mode={mode}
                />
            </div>
        </div>
    );
}